var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        title: "提单附件",
        width: "1200px",
        "show-close": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("BaseTable", {
            attrs: {
              height: 500,
              tableData: _vm.tableData,
              isPager: false,
              loading: false,
            },
            scopedSlots: _vm._u([
              {
                key: "opt",
                fn: function (row) {
                  return _c("div", { staticClass: "optbtn" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        attrs: { title: "查看" },
                        on: {
                          click: function ($event) {
                            return _vm.check(row.scope)
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-zoom-in" })]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        attrs: { title: "下载" },
                        on: {
                          click: function ($event) {
                            return _vm.download(row.scope)
                          },
                        },
                      },
                      [_c("i", { staticClass: "el-icon-download" })]
                    ),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }